export default "__VITE_ASSET__C05lpP6p__"